import {makeAutoObservable} from 'mobx';
import {serializable} from './sync/serialization';
import {type RootStore} from './Store';
import {utcSourcePhoneMap, partnerOfferIdPhoneMap} from './structures/phoneMaps';

class ConstStore {
    private parentStore: RootStore;

    @serializable()
    helpEmail = 'team@getamplifylife.com';

    @serializable()
    helpPhone = {
        href: '18556874399',
        displayValue: '855-687-4399',
    };

    @serializable()
    fartherHelpPhone = {
        href: '18556300212',
        displayValue: '855-630-0212',
    };

    @serializable()
    expertTeamPhone = '855-687-4399';

    @serializable()
    landing = 'https://www.getamplifylife.com/';

    constructor(parentStore: RootStore) {
        this.parentStore = parentStore;
        makeAutoObservable(this);
    }

    get displayedPhone() {
        if (this.parentStore?.userData) {
            const {utm, partners} = this.parentStore.userData;
            const key = utm.medium?.length ? `${utm.source}/${utm.medium}` : utm.source;
            if (key && utcSourcePhoneMap[key]) {
                return utcSourcePhoneMap[key];
            }

            if (partners?.offerId && partnerOfferIdPhoneMap[partners.offerId]) {
                return partnerOfferIdPhoneMap[partners.offerId];
            }
        }

        return this.helpPhone;
    }
}

export default ConstStore;
